import { Flex, Span, styled } from '@fareye/ui'
import React from 'react'
interface IKeyValue {
  backendKey: string
  label: string
  value: string
  keyStyle?: React.CSSProperties
  valueStyle?: React.CSSProperties
  layoutStyle?: React.CSSProperties
}
const LabelSpan = styled(Span)`
  font-size: 13px;
`
const GridKeyValue = styled(Flex)``
export default function KeyValueDetails(props: IKeyValue) {
  const { backendKey, value, label, keyStyle, valueStyle, layoutStyle } = props
  return (
    <GridKeyValue style={layoutStyle}>
      <LabelSpan data-id={backendKey} variant={'secondary'} style={keyStyle}>
        {label}
      </LabelSpan>
      <Span title={value} style={valueStyle}>
        {value}
      </Span>
    </GridKeyValue>
  )
}
